const freightFilterDataConfig = [
  {
    label: 'Last Modified Date',
    id: 'createdTimeRange',
    type: 'daterange',
    isDefaultExpanded: true
  },
  {
    label: 'FT ID',
    id: 'id',
    type: 'search',
    placeholder: 'FT Load Number'
  },
  {
    label: 'Load/Shipment ID',
    id: 'shipmentId',
    type: 'search',
    placeholder: 'Load/Shipment ID'
  },
  {
    label: 'Partner Name',
    id: 'partnerName',
    type: 'search',
    placeholder: 'Partner Name'
  },
  {
    label: 'Ingestion ID',
    id: 'ingestionId',
    type: 'search',
    placeholder: 'Ingestion ID'
  }
];

const outboundNotificationDataConfig = [
  {
    label: 'Created Time',
    id: 'createdTimeRange',
    type: 'daterange',
    isDefaultExpanded: true
  },
  {
    label: 'Entity ID',
    id: 'loadIds',
    type: 'search',
    placeholder: 'Entity ID'
  },
  {
    label: 'File Name',
    id: 'providerLoadIds',
    type: 'search',
    placeholder: 'File Name'
  },
  {
    label: 'Event Type',
    id: 'requestType',
    type: 'search',
    placeholder: 'Event Type'
  },
  {
    label: 'Customer Code',
    id: 'customerCodes',
    type: 'search',
    placeholder: 'Customer Code'
  },
  {
    label: 'Provider Code',
    id: 'providerCodes',
    type: 'search',
    placeholder: 'Provider Code'
  },
  {
    label: 'Response Time',
    id: 'timeTaken',
    type: 'numberLimit'
  },
  {
    label: 'Initial HttpStatus',
    id: 'initialResponseHttpStatus',
    type: 'numberRange'
  },
  {
    label: 'Response HttpStatus',
    id: 'responseHttpStatus',
    type: 'numberRange'
  },
  {
    label: 'Retry Count',
    id: 'retryCount',
    type: 'numberLimit'
  }
];

const customerAccessDataConfig = [
  {
    label: 'Created Time',
    id: 'createdTimeRange',
    type: 'daterange',
    isDefaultExpanded: true
  },
  {
    label: 'Entity ID',
    id: 'loadIds',
    type: 'search',
    placeholder: 'Entity ID'
  },
  {
    label: 'Network Service',
    id: 'targetService',
    type: 'search',
    placeholder: 'Network Service'
  },
  {
    label: 'Transaction Type',
    id: 'targetOperation',
    type: 'search',
    placeholder: 'Transaction Type'
  },
  {
    label: 'Response Status',
    id: 'responseStatus',
    type: 'search',
    placeholder: 'Response Status'
  },
  {
    label: 'Customer Code',
    id: 'customerCodes',
    type: 'search',
    placeholder: 'Customer Code'
  },
  {
    label: 'Provider Code',
    id: 'providerCodes',
    type: 'search',
    placeholder: 'Provider Code'
  },
  {
    label: 'Response Time',
    id: 'timeTaken',
    type: 'numberLimit'
  },
  {
    label: 'Initial HttpStatus',
    id: 'initialResponseHttpStatus',
    type: 'numberRange'
  },
  {
    label: 'Response HttpStatus',
    id: 'responseHttpStatus',
    type: 'numberRange'
  },
  {
    label: 'Retry Count',
    id: 'retryCount',
    type: 'numberLimit'
  }
];

const filterDataConfig = [
  {
    label: 'Created Time',
    id: 'createdTimeRange',
    type: 'daterange',
    isDefaultExpanded: true
  },
  {
    label: 'Operation',
    id: 'operations',
    type: 'search',
    placeholder: 'Operation'
  },
  {
    label: 'Load ID',
    id: 'loadIds',
    type: 'search',
    placeholder: 'Load ID'
  },
  {
    label: 'Provider Load ID',
    id: 'providerLoadIds',
    type: 'search',
    placeholder: 'Provider Load ID'
  },
  {
    label: 'Response status',
    id: 'responseStatus',
    type: 'search',
    placeholder: 'Response status'
  },
  {
    label: 'Customer Code',
    id: 'customerCodes',
    type: 'search',
    placeholder: 'Customer Code'
  },
  {
    label: 'Provider Code',
    id: 'providerCodes',
    type: 'search',
    placeholder: 'Provider Code'
  },
  {
    label: 'Provider Customer Code',
    id: 'providerCustomerCodes',
    type: 'search',
    placeholder: 'Provider Customer Code'
  },
  {
    label: 'Aggregator',
    id: 'aggregator',
    type: 'search',
    placeholder: 'Aggregator'
  },
  {
    label: 'Notification Type',
    id: 'requestType',
    type: 'search',
    placeholder: 'Notification Type'
  },
  {
    label: 'Response Time',
    id: 'timeTaken',
    type: 'numberLimit',
    placeholder: 'Response Time'
  },
  {
    label: 'Initial Response HttpStatus',
    id: 'initialResponseHttpStatus',
    type: 'numberRange',
    isCommon: true,
    isDefaultExpanded: false
  },
  {
    label: 'Response HttpStatus',
    id: 'responseHttpStatus',
    type: 'numberRange',
    isCommon: true,
    isDefaultExpanded: false
  },
  {
    label: 'Retry Count',
    id: 'retryCount',
    type: 'numberLimit',
    placeholder: 'Retry Count',
    isCommon: true
  }
];

const archiveDataConfig = [
  {
    label: 'Created Time',
    id: 'createdTimeRange',
    type: 'daterange',
    isDefaultExpanded: true
  },
  {
    label: 'Operation',
    id: 'operations',
    type: 'search',
    placeholder: 'Operation'
  },
  {
    label: 'Load ID',
    id: 'loadIds',
    type: 'search',
    placeholder: 'Load ID'
  },
  {
    label: 'Provider Load ID',
    id: 'providerLoadIds',
    type: 'search',
    placeholder: 'Provider Load ID'
  },
  {
    label: 'Customer Code',
    id: 'customerCodes',
    type: 'search',
    placeholder: 'Customer Code'
  },
  {
    label: 'Provider Code',
    id: 'providerCodes',
    type: 'search',
    placeholder: 'Provider Code'
  },
  {
    label: 'Provider Customer Code',
    id: 'providerCustomerCodes',
    type: 'search',
    placeholder: 'Provider Customer Code'
  },
  {
    label: 'Aggregator',
    id: 'aggregator',
    type: 'search',
    placeholder: 'Aggregator'
  },
  {
    label: 'Notification Type',
    id: 'requestType',
    type: 'search',
    placeholder: 'Notification Type'
  },
  {
    label: 'Response Time',
    id: 'timeTaken',
    type: 'numberLimit',
    placeholder: 'Response Time'
  },
  {
    label: 'Initial Response HttpStatus',
    id: 'initialResponseHttpStatus',
    type: 'numberRange',
    isCommon: true,
    isDefaultExpanded: false
  },
  {
    label: 'Response HttpStatus',
    id: 'responseHttpStatus',
    type: 'numberRange',
    isCommon: true,
    isDefaultExpanded: false
  },
  {
    label: 'Retry Count',
    id: 'retryCount',
    type: 'numberLimit',
    placeholder: 'Retry Count',
    isCommon: true
  }
];

const responseTimeData = [
  {
    id: 1,
    value: '<'
  },
  {
    id: 2,
    value: '>'
  }
];

export {
  freightFilterDataConfig,
  outboundNotificationDataConfig,
  customerAccessDataConfig,
  filterDataConfig,
  responseTimeData,
  archiveDataConfig
};
